const {bind} = require('./lib/bind')
import Sortable from 'sortablejs';

bind(document, 'DOMContentLoaded', function() {
  if(!document.getElementById('resource-links-list')) return
  
  let form = document.getElementById('resource_link_reorder')
  let input = document.getElementById('resource_order_ids')

  const sortable = Sortable.create(document.getElementById('resource-links-list'), {
    direction: 'vertical',
    handle: '.reorder-handle',
    onEnd: function(event) {
      const data = Array.from(event.target.children).map((el, index) => {
        return el.dataset.id
      })
      input.value = data
      form.submit()
    }
  })
});